export class Forget {
    email: string;
    userid: string;
    UrlCallback: string;
    SetPwd: boolean;
    NewPassword: string;
}
